export default __webpack_public_path__ + "static/media/Int_PAYFLOW.1ff848ed.svg";